/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, DocumentoOpera } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalUploadDocumentoComponent } from '../modal-upload-documento/modal-upload-documento.component';

@Component({
    selector: 'app-toolkit-opera-tab-documenti',
    templateUrl: './tab-documenti.component.html',
})
export class ToolkitGestioneOperaTabDocumentiComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() datalist: DatalistAnagrafica;
    @Input() items: DocumentoOpera[] = [];

    constructor(
        private modalService: NgbModal,
        private utilsService: UtilsService,
        private operaService: OperaService,
    ) { }


    ngOnInit(): void {
        this.operaService.documentoOperaByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: DocumentoOpera[]) => {
            this.items = list;
        });
    }
    
    public documentoOperaDownload(item: DocumentoOpera) {
        this.operaService.downloadDocumento(item).subscribe();
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalUploadDocumentoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.result.then(result => {
            if (result.file) {
                this.operaService.insertDocumento(result.file, this.operaService.operaSession.idOpera, result.form.getRawValue()).subscribe(responseInsert => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.documentoOperaByIdOpera(this.operaService.operaSession.idOpera).subscribe(response => {
                        this.items = response;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(documento: DocumentoOpera) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalUploadDocumentoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = documento;
        modal.result.then(result => {
            if (result) {
                this.operaService.updateDocumentoOpera(result.form.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.documentoOperaByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: DocumentoOpera[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idDocumento: number) {
        this.operaService.deleteDocumento(idDocumento).subscribe(responseDelete => {
            this.operaService.documentoOperaByIdOpera(this.operaService.operaSession.idOpera).subscribe(response => {
                this.items = response;
            });
        });
    }

}
